// eslint-disable-next-line no-console
export default () => console.log('react-advertising@4.2.14/UMD');
